/**
 * equalize-card-titles.js
 *
 * Keeps product-card titles the same height across:
 *  1. #product-grid / .country-showcase__grid — CSS Grids that wrap
 *     into multiple rows (titles are equalized per visual row only)
 *  2. .bb-fc-track    — a single-row horizontal carousel
 *     (all titles in the track are equalized together)
 *
 * This lets shorter titles get matching top padding so the
 * rating / price / Add to cart button underneath line up,
 * without any artificial CSS spacer or floating gaps.
 */

function equalizeGroup(headings) {
  if (!headings.length) return;

  // Reset first so we measure each title's natural height
  headings.forEach((el) => {
    el.style.minHeight = '';
  });

  const maxHeight = Math.max(...headings.map((el) => el.offsetHeight));

  headings.forEach((el) => {
    el.style.minHeight = maxHeight + 'px';
  });
}

function equalizeGridTitles(grid) {
  const headings = Array.from(grid.querySelectorAll('.card__heading'));
  if (!headings.length) return;

  // Reset first so getBoundingClientRect() reflects natural layout
  headings.forEach((el) => {
    el.style.minHeight = '';
  });

  // Group headings by their row using each one's top position
  const rows = {};
  headings.forEach((el) => {
    const top = Math.round(el.getBoundingClientRect().top);
    if (!rows[top]) rows[top] = [];
    rows[top].push(el);
  });

  Object.values(rows).forEach(equalizeGroup);
}

function equalizeCarouselTitles(track) {
  if (!track) return;
  // A carousel track is one continuous row — equalize every slide's
  // title together, including slides currently scrolled out of view.
  const headings = Array.from(track.querySelectorAll('.card__heading'));
  equalizeGroup(headings);
}

function runEqualize() {
  requestAnimationFrame(() => {
    document.querySelectorAll('#product-grid, .country-showcase__grid').forEach(equalizeGridTitles);
    document.querySelectorAll('.bb-fc-track').forEach(equalizeCarouselTitles);
  });
}

document.addEventListener('DOMContentLoaded', runEqualize);
window.addEventListener('load', runEqualize);
if (document.fonts) {
  document.fonts.ready.then(runEqualize);
}

let equalizeResizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(equalizeResizeTimer);
  equalizeResizeTimer = setTimeout(runEqualize, 150);
});

// Exposed so carousel-component (or any other dynamic content loader)
// can re-equalize a specific track/grid on demand, e.g. after facets.js
// replaces the product grid via AJAX, or after a ResizeObserver fires
// when slide content settles late.
window.equalizeCardTitlesTrack = equalizeCarouselTitles;
window.equalizeProductGrid = function () {
  document.querySelectorAll('#product-grid, .country-showcase__grid').forEach(equalizeGridTitles);
};